import { MCTitle } from "../utils/mockData";
import { useNavigate } from "react-router-dom";
import {
  BgImage,
  ImgCompareBox,
  StyledHeading,
  ContentWrapper,
  ViewMoreWrapper,
} from "../components/viewCasesComponent/viewMoreMetalCeramics/ViewMoreMetalCeramics.styled";
import { Box } from "@chakra-ui/react";
import ImageViewer from "react-simple-image-viewer";
import React, { useState, useCallback } from "react";
import { ImagesMC } from "../utils/mockData";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { StyledAiOutlineArrowLeft } from "../common/styles/common.styled";

export const ViewMoreMetalCeramics = () => {
  const [t, i18] = useTranslation();
  const navigate = useNavigate();

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    document.title = t("Kreativa");
  }, [i18.resolvedLanguage, t]);

  return (
    <Box backgroundColor="#f7f7f7" h="100%">
      {isViewerOpen && (
        <ImageViewer
          src={ImagesMC}
          currentIndex={currentImage}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={closeImageViewer}
        />
      )}
      <StyledHeading className="StyledHeading">
        <StyledAiOutlineArrowLeft onClick={() => navigate(-1)} />
        {t(MCTitle.title)}
      </StyledHeading>
      <ContentWrapper>
        <ViewMoreWrapper>
          <ImgCompareBox>
            {MCTitle.imgArr.map((img, index) => (
              <BgImage
                imgSrc={img}
                onClick={() => openImageViewer(index)}
              ></BgImage>
            ))}
          </ImgCompareBox>
        </ViewMoreWrapper>
      </ContentWrapper>
    </Box>
  );
};
